import { cx } from '@linaria/core';
import { spacingCls, headingsCls, containerCls } from '@pm2/text-component/selectors';
import { usePrintedAST, makeHtmlNodeToJsxPrinter, textNodeToJsxPrinter, generateJsxKey } from '@utils/ast';
import { NoSSR } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { AudioPlayer } from '../../../atom.audio/_audio-player.full.js';
import { VideoMedia } from '../../../molecule.media/video.js';
import { wrapper, audioPlayer } from './_infopage.style.js';
import { printImage } from './printer.image.js';
import { printLink } from './printer.link.js';
import { printCell, printTable } from './printer.table.js';
import { jsx } from 'react/jsx-runtime';

const htmlPrinters = makeHtmlNodeToJsxPrinter({
  handleTag: (tag, data, context) => {
    switch (tag) {
      case "table":
        return printTable(data, context);
      case "th":
      case "td":
        return printCell(tag, data, context);
      case "img":
        return printImage(data, context);
      case "a":
        return printLink(data, context);
      default:
        return undefined;
    }
  }
}, () => printers);
const printers = {
  text: textNodeToJsxPrinter,
  html: htmlPrinters,
  "inline-audio": (node, context) => /*#__PURE__*/jsx(AudioPlayer, {
    src: node.src,
    className: audioPlayer
  }, generateJsxKey(context)),
  "video-23": (node, context) => /*#__PURE__*/jsx(VideoMedia, {
    node: {
      type: "Video",
      showInLightbox: false,
      title: null,
      twentyThreeVideo: node.twentyThreeVideo
    }
  }, generateJsxKey(context))
};
function InfoPageTask(props) {
  const pageContext = usePageContext();
  const content = usePrintedAST(props.task.content, printers);
  return /*#__PURE__*/jsx("div", {
    className: cx(wrapper, spacingCls, headingsCls, containerCls),
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsx(NoSSR, {
      children: content
    })
  });
}

export { InfoPageTask };
//# sourceMappingURL=_infopage.js.map
